module.exports = __webpack_public_path__ + "static/media/lunar-logo@3x.52dd8f32.png";